import { render, staticRenderFns } from "./ShaItem.vue?vue&type=template&id=5513f699"
import script from "./ShaItem.vue?vue&type=script&lang=js"
export * from "./ShaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports